import { render } from "./MainUsers.vue?vue&type=template&id=7027f3e1&scoped=true"
import script from "./MainUsers.vue?vue&type=script&lang=js"
export * from "./MainUsers.vue?vue&type=script&lang=js"

import "./MainUsers.vue?vue&type=style&index=0&id=7027f3e1&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7027f3e1"]])

export default __exports__